<template>
  <!-- 树形结构管理 -->
  <!-- 树形结构添加下级 -->
  <a-modal :title="title" v-dragModal :width="1000" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false"
    :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" :labelCol="labelCol" :wrapperCol="wrapperCol" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')">
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" layout="horizontal" :model="model" :rules="validatorRules">
        <a-row :gutter="24">
          <a-col :xl="24" :lg="12" :md="12" :sm="24">
            <a-form-model-item :label="$t('名称')" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="treeName">
              <a-input :placeholder="$t('请输入名称')" v-model="model.treeName" />
            </a-form-model-item>
          </a-col>

          <a-col :xl="24" :lg="12" :md="12" :sm="24">

            <!-- 添加主目录 -->
            <a-form-model-item v-if="maximumParent == '1'" :label="$t('上级')"  :labelCol="labelCol" :wrapperCol="wrapperCol"
              prop="treeCategory">
              <!-- 分类树字典调用 -->
              <j-search-select-tag v-model="model.treeCategory" :placeholder="$t('请选择')" :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                dict="classificationTree" />
            </a-form-model-item>

            <!-- 添加子类 -->
            <a-form-model-item v-if="maximumParent == '2'" :label="$t('分类')" :hidden="seen"  :labelCol="labelCol" :wrapperCol="wrapperCol"
              prop="treeParentId">
              <a-tree-select style="width:100%" :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }" :treeData="treeData" v-model="model.treeParentId"
                :placeholder="$t('无')" :disabled="condition">
              </a-tree-select>

            </a-form-model-item>

          </a-col>
          <a-col :xl="24" :lg="12" :md="12" :sm="24" >
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('排序')" prop="sortNo">
              <a-input :placeholder="$t('请输入排序')" v-model="model.sortNo" />
            </a-form-model-item>
          </a-col>

          <a-col :xl="24" :lg="12" :md="12" :sm="24">
            <a-form-model-item :label="$t('备注')" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="treeRemark">
              <a-input :placeholder="$t('请输入备注')" v-model="model.treeRemark" />
            </a-form-model-item>

          </a-col>

        </a-row>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction, getAction } from '@/api/manage';
import JMultiSelectTag from '@/components/dict/JMultiSelectTag';
import cronValidator from "@/components/jeecg/JEasyCron/validator";
import JUpload from '@/components/jeecg/JUpload';
import { paramsToFormData } from '@/utils/util';
import JSelectMultiUser from '@/components/jeecgbiz/JSelectMultiUser';
import { duplicateCheck } from '@/api/api'
export default {
  components: {
    JMultiSelectTag,
    JUpload
  },
  data() {
    return {
      maximumParent: '', //判断是否为最顶级新增弹框
      title: this.$t('操作'),
      buttonStyle: 'solid',
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      cron: {
        label: '',
        value: ''
      },
      fileList: [],
      treeData: [],
      confirmLoading: false,
      updata: false,
      seen: false,
      condition: true,
      Update: 0,  //父级类型  treeCategory
      url: {
        add: "/jeecg-engineering/sample/treeData/add",
        edit: "/jeecg-engineering/sample/treeData/edit",
        queryDepartTreeSync: '/jeecg-engineering/sample/treeData/queryTreeList',
      },
    }
  },
  computed: {
    validatorRules() {
      return {
        treeName: [
          { required: true, message: this.$t('请输入名称!') },
          { validator: this.validatetreeCategory, }
        ],
        sortNo: [
          { required: true, message: this.$t('请输入排序!'), },
          { required: false, pattern: /^[0-9]*$/, message: this.$t('请输入正确的排序!') },
        ],
        treeCategory: [
          { required: true, message: this.$t('请选择上级!'), },
        ],
      }
    }
  },
  created() {
  },
  methods: {
    add(num, props, depart) {
      this.visible = true;
      // 新增主类
      if (num == 1) {
        this.maximumParent = '1'
        this.edit(num); //编辑的所有回显
        // this.Update =this.model.treeParentId;
      } else {
        this.maximumParent = '2'
        // 添加子类数据回显
        this.Update = props;
        this.loadTree();
        console.log("我看看现在返回的是啥", depart);
        if (depart == undefined) {
          //顶级父类新增打开
          // this.updata = false; //子级新增的部分回显
          // this.edit(num);
        } else {
          //子级父类新增打开
          // this.updata = true;
          this.edit(num, depart); //编辑的所有回显
        }
        // 统一设置默认值

      }

    },
    // record传过来的key
    edit(num, record) {
      this.visible = true;
      this.$nextTick(() => {
        if (num == 1) {

          this.model = Object.assign( { treeCategory: this.model.treeParentId });
        } else if (num == 2) {
          // 添加子级父类 打开窗口
          this.model = Object.assign( { treeParentId: record, treeCategory: this.Update });

        } else if (num == 3) {
          //编辑 数据回显
          if (record.parentId == "0") {
            // 有顶级父级的方法名称
            this.maximumParent = '1'
            // let params = { treeParentId: record.treeCategory };
            this.model = Object.assign({}, record);

          } else {
            let params = { treeParentId: record.parentId };
            this.model = Object.assign(params, record);
          }
        }
      })
    },
    loadTree() {
      let params = { treeCategory: this.Update }
      this.treeData = []
      getAction(this.url.queryDepartTreeSync, params).then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            this.treeData.push(temp);
          }
        }
      })
    },
    close() {
      this.visible = false;
      this.model = this.$options.data.call(this).model;
    },
    // 点击确定
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate((ok, err) => {
        if (ok) {
          that.confirmLoading = true;
          let params = { ...this.model }
          let httpurl = '';
          let method = '';
          console.log(this.model, '看看走新增还是编辑');
          if (!this.model.id) { //添加
            httpurl += this.url.add;
            method = 'post';
          } else {//编辑
            httpurl += this.url.edit;
            method = 'put';
          }

          httpAction(httpurl, params, method).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.close();
            } else {
              that.$message.warning(res.message);
            }
            this.$emit('ok')
          }).finally(() => {
            that.confirmLoading = false;
          })


        }

      })
    },

    handleCancel() {
      this.close()
    },
    validatetreeCategory(rule, value, callback) {
      var params = {
        tableName: 'v_tree_data',
        fieldName: 'tree_name',
        fieldVal: value,
        dataId: this.model.id
      };
      duplicateCheck(params).then((res) => {
        if (res.success) {
          callback()
        } else {
          callback(this.$t("分类名称已存在!"))
        }
      })
    },
  }
}
</script>

<style scoped>
/deep/ .ant-checkbox-group {
  height: 32px;
}

/* /deep/ .ant-form-item-required::before {
  display: none;
} */
/* /deep/ .ant-form-item-control {
  height: 32px;
} */
</style>